import styled from "styled-components";
import {Button, Col, Input, InputNumber, Row} from "antd";

export const Layout = styled.div`
  width: 520px;
  margin: auto;
  display: flex;
  flex-direction: column;
`;


export const FormGroup = styled.div`
  //  height: 38px;
  //line-height: 38px;
  //margin-bottom: 15px;
  .ant-form-item-label {
    
    & > label {
      height: 36px;  
    }
  }
`;
export const FormLabel = styled(Col)`
  color: #222;
  padding-right: 16px;
  text-align: right;
  font-size: 12px;
`

export const FormInput = styled(Input)`
  padding: 6px 11px;
  border-radius: 0;
`;
export const FormInputNumber = styled(InputNumber)`
  //padding: 6px 11px;
  padding: 3px 0px;
  border-radius: 0;
  .ant-input-number-handler-wrap {
    display: none;
  }
`

export const ExchangeButton = styled(Button)`
  //background: #e63b2a;
  //color: #fff;
  font-size: 14px;
  //border: none;
  //&:not(:disabled):not(.ant-btn-disabled):hover {
  //  color: #fff;
  //}
`;